export default "__VITE_ASSET__CoaqGZdG__$_?url__"